// extracted by mini-css-extract-plugin
module.exports = {"main":"GamesOther_main__FpEo0","title":"GamesOther_title__5pp9P"};